import { render, staticRenderFns } from "./createActivity.vue?vue&type=template&id=a4f4f610&"
import script from "./createActivity.vue?vue&type=script&lang=js&"
export * from "./createActivity.vue?vue&type=script&lang=js&"
import style0 from "./createActivity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports